import styled from 'styled-components';
import { Fab } from '@mui/material';

import colors from '@/styles/colors';

export const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${colors.darker};
  color: ${colors.light};
  width: 100%;
  height: 30px;
`;

export const StyledTopButton = styled.div`
  bottom: 1rem;
  position: fixed;
  right: 1rem;
`;

export const StyledFab = styled(Fab)`
  color: ${colors.lighter}!important;
  background: linear-gradient(${colors.black}, ${colors.primary}) !important;
  animation: pulse 1s ease infinite;

  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
    }
  }
`;
